<template>
  <div>
    <v-container v-if="isRecomendationDetected">
      <v-row justify="space-between">
        <v-col>
          <v-skeleton-loader
            :loading="loadingPastEvent"
            type="list-item"
            max-width="200"
          >
            <h3 class="d-inline-block">Cocok untuk kamu ikuti</h3>
            <p class="grey--text">
              Semua event di Fakultas <strong>{{ facultyName }}</strong>
            </p>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-if="loadingPastEvent">
        <v-col cols="12" md="3" v-for="(item, i) in 8" :key="i">
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          sm="6"
          md="3"
          v-for="(item, i) in loadDataPastEvents"
          :key="i"
        >
          <PosterCard
            :title="item.title"
            :date="item.event_date"
            :is_post_event="item.post_event"
            :publisher="item.publisher"
            :publisher_badge="item.publisher_badge"
            :poster="item.cover"
            :route="{
              name: 'EventDetail',
              params: { slug: item.slug, id: item.id },
            }"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Axios from 'axios';
import PosterCard from './PosterCard';

export default {
  name: 'CatalogueEventRecommendation',
  components: {
    PosterCard,
  },
  data() {
    return {
      loadingPastEvent: true,
      loadDataPastEvents: [],
      errorPastEvents: false,
      errorMessagePastEvents: null,
      isRecomendationDetected: false,
      user: JSON.parse(localStorage.getItem('user')),
      facultyName: null,
    };
  },
  mounted() {
    if (localStorage.getItem('token') != null && this.user.faculty != null) {
      this.isRecomendationDetected = true;
      this.facultyName = this.user.faculty;
      this.loadDataRecommendation(this.user.faculty_id);
    } else {
      this.loadingPastEvent = false;
    }

    // console.log(this.isRecomendationDetected);
  },
  methods: {
    loadDataRecommendation(val) {
      Axios.get(process.env.VUE_APP_API + 'events?faculty_id=' + val)
        .then((response) => {
          this.loadDataPastEvents = response.data.data;
        })
        .catch((error) => {
          // console.log(error);
          this.errorPastEvents = true;
          this.errorMessagePastEvents = error;
        })
        .finally(() => (this.loadingPastEvent = false));
    },
  },
};
</script>

<style scoped></style>
